import { createFileRoute } from "@tanstack/react-router";
import PartnerErecht24Page from "@/pages/PartnerErecht24Page";
import { buildRouteHead } from "@/lib/route-head";
import { breadcrumbSchema } from "@/lib/schema";

const webPageSchema = {
  type: "application/ld+json",
  children: JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "eRecht24 Premiumpartner",
    description:
      "Informationen zur eRecht24-Premiumpartnerschaft von Enno & Jens und zum Kundennutzen durch rechtssicheres Impressum und rechtssichere Datenschutzerklärung.",
    url: "https://www.enno-und-jens.de/netzwerk/erecht24",
    isPartOf: { "@id": "https://www.enno-und-jens.de/#website" },
    about: { "@type": "Thing", name: "eRecht24 Premiumpartnerschaft" },
  }),
};

export const Route = createFileRoute("/netzwerk/erecht24")({
  head: () =>
    buildRouteHead({
      title: "eRecht24 Premiumpartner | Rechtssichere Website-Texte",
      description:
        "Als eRecht24-Premiumpartner unterstützen wir Kunden mit rechtssicherem Impressum und rechtssicherer Datenschutzerklärung als festen Bestandteil ihrer Website.",
      path: "/netzwerk/erecht24",
      image: "/images/partners/erecht24-1024.webp",
      imageAlt: "Rechtssichere Website-Texte für Impressum und Datenschutz",
      imageWidth: 1024,
      imageHeight: 730,
      scripts: [
        breadcrumbSchema([
          { name: "Startseite", path: "/" },
          { name: "Netzwerk", path: "/netzwerk" },
          { name: "eRecht24 Premiumpartner", path: "/netzwerk/erecht24" },
        ]),
        webPageSchema,
      ],
    }),
  component: PartnerErecht24Page,
});
